/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StatusItemDto
 */
export interface StatusItemDto {
    /**
     *
     * @type {number}
     * @memberof StatusItemDto
     */
    statusItemId?: number;
    /**
     *
     * @type {string}
     * @memberof StatusItemDto
     */
    deviceIdentity?: string;
    /**
     *
     * @type {number}
     * @memberof StatusItemDto
     */
    connectorIndex?: number;
    /**
     *
     * @type {Date}
     * @memberof StatusItemDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof StatusItemDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {string}
     * @memberof StatusItemDto
     */
    status?: string;
}

/**
 * Check if a given object implements the StatusItemDto interface.
 */
export function instanceOfStatusItemDto(value: object): value is StatusItemDto {
    return true;
}

export function StatusItemDtoFromJSON(json: any): StatusItemDto {
    return StatusItemDtoFromJSONTyped(json, false);
}

export function StatusItemDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): StatusItemDto {
    if (json == null) {
        return json;
    }
    return {
        statusItemId:
            json["statusItemId"] == null ? undefined : json["statusItemId"],
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        status: json["status"] == null ? undefined : json["status"],
    };
}

export function StatusItemDtoToJSON(value?: StatusItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        statusItemId: value["statusItemId"],
        deviceIdentity: value["deviceIdentity"],
        connectorIndex: value["connectorIndex"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        status: value["status"],
    };
}
